
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job",
      function () {
        return require("private-next-pages/job.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job"])
      });
    }
  